import createSchemaMiddleware from 'structure-validation-schema-middleware'

export default createSchemaMiddleware(
  {
    "properties": {
      "desc": {
        "type": "string"
      },
      "title": {
        "type": "string"
      }
    },
    "required": ["title"]
  }
)
